/* eslint-disable camelcase */
import dayjs from 'dayjs';

import { groupBy } from 'lodash';
import { IBaseRowData } from 'types/table.types';

import { isControlRow } from '.';

export const dateParsing = (dateString: string) => {
  const parts = dateString.split('/');
  return new Date(
    parseInt(parts[2], 10),
    parseInt(parts[1], 10) - 1,
    parseInt(parts[0], 10)
  );
};

export const daysDifference = (date1: Date, date2: Date) => {
  const diffTime: number = date1.valueOf() - date2.valueOf();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

export const formatDate = (dateString: string | Date | null | undefined) => {
  if (!dateString) {
    return undefined;
  }

  const date = dateString instanceof Date ? dateString : new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return dateString as string;
  }
  return date.toLocaleDateString('en-UK');
};

export const groupByMonday = <R extends IBaseRowData>(data: R[]) => {
  const dataWithMonday = data.map((row) => ({
    ...row,
    mondayOfWeek:
      row.mondayOfWeek
      ?? dayjs(row.collection_date).startOf('week').add(1, 'day').toString(),
  }));
  const nonControlRows = dataWithMonday.filter((row) => !isControlRow(row));

  return groupBy(nonControlRows, 'mondayOfWeek');
};
